module.exports = __webpack_public_path__ + "static/flute_en-9ba2033d6e3317cb8d39187ebb2c9451.pdf";